import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Resolve,Router, RouterStateSnapshot, RouterLink } from '@angular/router';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.css']
})
export class UnsubscribeComponent implements OnInit {

  constructor(private routerr: ActivatedRoute,
  
    private nav:Router ) {  }

  ngOnInit() {
  }
  getFullYear(){
    return new Date().getFullYear();
  }

}
